import { render, staticRenderFns } from "./NoOrders.vue?vue&type=template&id=53d49042&scoped=true&"
import script from "./NoOrders.vue?vue&type=script&lang=js&"
export * from "./NoOrders.vue?vue&type=script&lang=js&"
import style0 from "./NoOrders.vue?vue&type=style&index=0&id=53d49042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d49042",
  null
  
)

export default component.exports